module.exports = (__webpack_require__(2))("./core/tabbar.js");


//////////////////
// WEBPACK FOOTER
// delegated ./core/tabbar.js from dll-reference base
// module id = 101
// module chunks = 22